import { render, staticRenderFns } from "./Loaders.vue?vue&type=template&id=4ccce5b0&scoped=true&"
import script from "./Loaders.vue?vue&type=script&lang=js&"
export * from "./Loaders.vue?vue&type=script&lang=js&"
import style0 from "./Loaders.vue?vue&type=style&index=0&id=4ccce5b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccce5b0",
  null
  
)

export default component.exports